/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

/*
var euLanguages = ['de', 'es', 'fr', 'it', 'nl'];
var pageLanguage = document.querySelector('body').getAttribute('data-page-language');  // alternativ document.documentElement.lang
var dynamicMode = euLanguages.includes(pageLanguage) ? 'opt-in' : 'opt-out';
var showConsent = euLanguages.includes(pageLanguage) ? true : false;
var setEnabled = euLanguages.includes(pageLanguage) ? false : true;
*/

const showConsent = document.querySelector(".js-manage-cookie-prefs") ? false : true;  // auf Datenschutz Seite Cookie Consent nicht autom. anzeigen
if(showConsent){  // 18.11.2024 - nach 500ms anzeigen
    setTimeout(CookieConsent.show, 500);
}

CookieConsent.run({
    // root: 'body',  // '#app'  // css selector
    autoShow: false,  // 18.11.2024 - wird nun oben mit settimeout gemacht, vorher hier showConsent (true, false)
    disablePageInteraction: true,
    // hideFromBots: true,
    mode: 'opt-in',  // 'opt-in' (default) | 'opt-out'
    revision: 1.1,

    cookie: {
        name: 'cc_cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        expiresAfterDays: acceptType => {
            return acceptType === 'all'
                ? 365.25
                : 182;
        }
    },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'bottom center',
            equalWeightButtons: false,
            flipButtons: false
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: false,
            flipButtons: false
        }
    },

    onFirstConsent: ({cookie}) => {
        logConsent();
    },
    /*
    onConsent: ({cookie}) => {
        console.log('onConsent fired!', cookie);
    },
    */
    onChange: ({changedCategories, changedServices}) => {
        logConsent();
    },
    /*
    onModalReady: function ({modalName}){
        console.log('ready:', modalName);
    },
    */
    onModalShow: ({modalName}) => {
        showConsentID();
        // workaround/bugfix https://github.com/orestbida/cookieconsent/issues/696
        var checked_services = document.querySelectorAll('#cc-main .pm__section-services input.section__toggle:checked');
        checked_services.forEach (function (elem) {
            elem.dispatchEvent(new Event('change'));
        });
    },
    /*
    onModalHide: ({modalName}) => {
        console.log('hidden:', modalName);
    },
    */

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true,  // this category cannot be disabled
            services: {
                wishbob: {
                    label: 'Wishbob Cookies',
                    //onAccept: function(){},
                    //onReject: function(){}
                },
                google_tag_manager: {
                    label: 'Google Tag Manager',  // ähnlich wie bei ÖAMTC
                    //onAccept: function(){},
                    //onReject: function(){}
                },
            }
        },
        analytics: {
            enabled: false,
            autoClear: {
                //reloadPage: true,  // Todo - überlegen, ob wir die Seite neu laden müssen
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },
            // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            services: {
                ga: {
                    label: 'Google Analytics',
                    //onAccept: function(){},
                    //onReject: function(){}
                }
            }
        },
        marketing: {
            enabled: false,
            autoClear: {
                //reloadPage: true,  // Todo - überlegen, ob wir die Seite neu laden müssen
                cookies: [
                    {
                        name: /^_fb/,   // regex: match all cookies starting with '_fb' - Facebook
                    },
                    {
                        name: /^_uet/,   // regex: match all cookies starting with '_fb' - Microsoft
                    }
                ]
            },
            services: {
                google_ads: {
                    label: 'Google Ads',
                    //onAccept: function(){},
                    //onReject: function(){}
                },
                microsoft_ads: {
                    label: 'Microsoft Advertising',
                    //onAccept: function(){},
                    //onReject: function(){}
                },
                facebook: {
                    label: 'Facebook',
                    //onAccept: function(){},
                    //onReject: function(){}
                }
            }
        }
    },
    language: {
        default: 'en',
        autoDetect: "document",  // 'document': retrieve language from the lang attribute (e.g. <html lang="en-US">) | 'browser': retrieve the user's browser language via navigator.language
        translations: {
            en: {
                 "consentModal": {
                    "label": "Cookie consent",
                    "title": "This website uses cookies",
                    "description": "Welcome to Wishbob! We use cookies, pixels and other similar technologies to provide you with an optimal experience with our wishlists. In addition, we analyze the behavior of our users in order to continuously improve Wishbob. Therefore, please give us your trust and allow us to use these features. You can freely choose the settings and also adjust them afterwards.",
                    "acceptAllBtn": "Accept all",
                    "acceptNecessaryBtn": "Reject all",
                    "showPreferencesBtn": "Manage preferences",
                    "footer": "<a href=\"/privacy\">Privacy Policy</a>"
                },
                "preferencesModal": {
                    "title": "Privacy settings",
                    "acceptAllBtn": "Accept all",
                    "acceptNecessaryBtn": "Reject all",
                    "savePreferencesBtn": "Save preferences",
                    "closeIconLabel": "Close window",
                    "serviceCounterLabel": "Services",
                    "sections": [
                        {
                            "title": "Cookie Usage",
                            "description": "We use cookies, pixels and similar technologies to provide you with an optimal experience with our wish lists. In addition, we analyze the behavior of our users in order to continuously improve Wishbob."
                        },
                        {
                            "title": "Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            "description": "Necessary cookies are required for the website to work. Because they enable the basic functions of the site, they cannot be disabled.",
                            "linkedCategory": "necessary"
                        },
                        {
                            "title": "Analytics Cookies",
                            "description": "Analytics cookies collect information about how websites are used. Information is collected anonymously in order to improve the content and functionality of Wishbob for its users.",
                            "linkedCategory": "analytics",
                        },
                        {
                            "title": "Marketing Cookies",
                            "description": "Marketing cookies are used to track website visitors.",
                            "linkedCategory": "marketing"
                        },
                        {
                            "title": "More information",
                            "description": "You can find more information under <a class=\"cc__link\" href=\"/privacy\">privacy policy</a>."
                        },
                        {
                            "title": "Your consent ID",
                            "description": "<span id=\"js-cc-cookie-consent-id\"></span>"
                        }
                    ]
                }
            },

            de: {
                "consentModal": {
                    "label": "Cookie-Zustimmung",
                    "title": "Diese Webseite verwendet Cookies",
                    "description": "Willkommen bei Wishbob! Wir verwenden Cookies, Pixel und ähnliche Technologien, um ein optimales Erlebnis mit unseren Wunschlisten zu ermöglichen. Darüber hinaus analysieren wir das Verhalten unserer Nutzer:innen, um Wishbob kontinuierlich zu verbessern. Bitte schenke uns daher dein Vertrauen und erlaube uns die Nutzung dieser Funktionen. Du kannst die Einstellungen frei wählen und auch im Nachhinein anpassen.",
                    "acceptAllBtn": "Alle akzeptieren",
                    "acceptNecessaryBtn": "Alle ablehnen",
                    "showPreferencesBtn": "Einstellungen verwalten",
                    "footer": "<a href=\"/datenschutz\">Datenschutz</a>"
                },
                "preferencesModal": {
                    "title": "Privatsphäre-Einstellungen",
                    "acceptAllBtn": "Alle akzeptieren",
                    "acceptNecessaryBtn": "Alle ablehnen",
                    "savePreferencesBtn": "Einstellungen speichern",
                    "closeIconLabel": "Fenster schließen",
                    "serviceCounterLabel":"Dienstleistungen",
                    "sections": [
                        {
                            "title": "Verwendung von Cookies",
                            "description": "Wir verwenden Cookies, Pixel und ähnliche Technologien, um ein optimales Erlebnis mit unseren Wunschlisten zu ermöglichen. Darüber hinaus analysieren wir das Verhalten unserer Nutzer:innen, um Wishbob kontinuierlich zu verbessern."
                        },
                        {
                            "title": "Notwendig <span class=\"pm__badge\">Immer aktiviert</span>",
                            "description": "Notwendige Cookies sind erforderlich, um die Webseite nutzbar zu machen. Da diese die Grundfunktionen der Webseite ermöglichen, können sie nicht deaktiviert werden.",
                            "linkedCategory": "necessary"
                        },
                        {
                            "title": "Statistik",
                            "description": "Statistik-Cookies sammeln Informationen darüber, wie Webseiten genutzt werden. Dazu werden anonym Informationen gesammelt, um wiederum die Inhalte und Funktionalität von Wishbob für die Benutzer:innen zu verbessern.",
                            "linkedCategory": "analytics",
                        },
                        {
                            "title": "Marketing",
                            "description": "Marketing-Cookies werden verwendet, um Besucher:innen auf Webseiten zu folgen.",
                            "linkedCategory": "marketing"
                        },
                        {
                            "title": "Weitere Informationen",
                            "description": "Weitere Informationen findest du unter <a class=\"cc__link\" href=\"/datenschutz\">Datenschutz</a>."
                        },
                        {
                            "title": "Deine Einwilligungs-ID",
                            "description": "<span id=\"js-cc-cookie-consent-id\"></span>"
                        }
                    ]
                }
            },
            es: {
                "consentModal": {
                    "label": "Consentimiento de cookies",
                    "title": "Este sitio web utiliza cookies",
                    "description": "Bienvenido a Wishbob. Utilizamos cookies, píxeles y tecnologías similares para ofrecer una experiencia optimizada con nuestras listas de deseos. Además, analizamos el comportamiento de nuestros usuarios para mejorar continuamente Wishbob. Por lo tanto, por favor, danos tu confianza y permítenos utilizar estas funciones. Puedes elegir libremente la configuración y también ajustarla posteriormente.",
                    "acceptAllBtn": "Aceptar todo",
                    "acceptNecessaryBtn": "Rechazar todo",
                    "showPreferencesBtn": "Gestionar la configuración",
                    "footer": "<a href=\"/politica-privacidad\">Política de privacidad</a>"
                },
                "preferencesModal": {
                    "title": "Privacidad",
                    "acceptAllBtn": "Aceptar todo",
                    "acceptNecessaryBtn": "Rechazar todo",
                    "savePreferencesBtn": "Guardar preferencias",
                    "closeIconLabel": "Cerrar ventana",
                    "serviceCounterLabel" :"Servicios",
                    "sections": [
                        {
                            "title": "Uso de cookies",
                            "description": "Utilizamos cookies, píxeles y tecnologías similares para ofrecer una experiencia optimizada con nuestras listas de deseos. Además, analizamos el comportamiento de nuestros usuarios para mejorar continuamente Wishbob."
                        },
                        {
                            "title": "Cookies necesarias <span class=\"pm__badge\">Siempre habilitado</span>",
                            "description": "Las cookies necesarias son esenciales para que Wishbob sea práctico permitiendo funciones básicas del sitio web. El sitio web no puede funcionar correctamente sin estas cookies y, por lo tanto, no se pueden desactivar.",
                            "linkedCategory": "necessary"
                        },
                        {
                            "title": "Cookies analíticas",
                            "description": "Las cookies analíticas recopilan información sobre cómo se utilizan los sitios web. La información se recopila de forma anónima con el fin de mejorar el contenido y la funcionalidad de Wishbob para los usuarios.",
                            "linkedCategory": "analytics",
                        },
                        {
                            "title": "Cookies marketing",
                            "description": "Las cookies de marketing se utilizan para identificar a los visitantes de sitios web que han visitado previamente otro sitio web.",
                            "linkedCategory": "marketing"
                        },
                        {
                            "title": "Para más información",
                            "description": "Encontrará más información en <a class=\"cc__link\" href=\"/politica-privacidad\">política de privacidad</a>."
                        },
                        {
                            "title": "Su ID de consentimiento",
                            "description": "<span id=\"js-cc-cookie-consent-id\"></span>"
                        }

                    ]
                }
            },
            fr: {
                 "consentModal": {
                    "label": "Consentement aux cookies",
                    "title": "Ce site utilise des cookies",
                    "description": "Bienvenue chez Wishbob ! Nous utilisons des cookies, des pixels et des technologies similaires pour offrir une expérience optimale avec nos listes de cadeaux. Nous analysons  également le comportement de nos utilisateurs afin d'améliorer continuellement Wishbob. Merci de nous faire confiance et de nous permettre d'utiliser ces fonctions. Vous pouvez choisir librement les paramètres et les adapter ultérieurement.",
                    "acceptAllBtn": "Tout accepter",
                    "acceptNecessaryBtn": "Tout rejeter",
                    "showPreferencesBtn": "Gérer les préférences",
                    "footer": "<a href=\"/politique-confidentialite\">Politique de confidentialité</a>"
                },
                "preferencesModal": {
                    "title": "Paramètres de confidentialité",
                    "acceptAllBtn": "Tout accepter",
                    "acceptNecessaryBtn": "Tout rejeter",
                    "savePreferencesBtn": "Sauvegarder les préférences",
                    "closeIconLabel": "Fermer la fenêtre",
                    "serviceCounterLabel": "Services",
                    "sections": [
                        {
                            "title": "Utilisation des Cookies",
                            "description": "Nous utilisons des cookies, des pixels et des technologies similaires pour offrir une expérience optimale avec nos listes de cadeaux. En outre, nous analysons le comportement de nos utilisateurs afin d'améliorer continuellement Wishbob."
                        },
                        {
                            "title": "Cookies Nécessaires <span class=\"pm__badge\">Toujours Activé</span>",
                            "description": "Les cookies nécessaires sont indispensables à l'utilisation du site web. Comme ils permettent les fonctions de base du site web, ils ne peuvent pas être désactivés.",
                            "linkedCategory": "necessary"
                        },
                        {
                            "title": "Cookies statistiques",
                            "description": "Les cookies statistiques collectent des informations sur la manière dont les sites web sont utilisés. Les informations sont collectées de manière anonyme afin d'améliorer le contenu et les fonctionnalités de Wishbob pour les utilisateurs.",
                            "linkedCategory": "analytics",
                        },
                        {
                            "title": "Cookies Marketing",
                            "description": "Les cookies marketing sont utilisés pour suivre les visiteurs du site web.",
                            "linkedCategory": "marketing"
                        },
                        {
                            "title": "Plus d'informations",
                            "description": "Vous trouverez plus d'informations sous <a class=\"cc__link\" href=\"/politique-confidentialite\">politique de confidentialité</a>."
                        },
                        {
                            "title": "Votre ID de consentement",
                            "description": "<span id=\"js-cc-cookie-consent-id\"></span>"
                        }

                    ]
                }
            },
            it: {
                "consentModal": {
                    "label": "Consenso sui cookie",
                    "title": "Questo sito web utilizza i cookie",
                    "description": "Benvenuto su Wishbob! Utilizziamo cookie, pixel e tecnologie simili per offrire un'esperienza ottimale con le nostre liste dei desideri. Inoltre analizziamo il comportamento dei nostri utenti per migliorare costantemente Wishbob. Pertanto, ti preghiamo di darci la tua fiducia e di permetterci di utilizzare queste funzioni. Puoi scegliere liberamente le impostazioni e modificarle anche in seguito.",
                    "acceptAllBtn": "Accetta tutto",
                    "acceptNecessaryBtn": "Rifiuta tutto",
                    "showPreferencesBtn": "Gestisci preferenze",
                    "footer": "<a href=\"/protezione-dati\">Protezione dati</a>"
                },
                "preferencesModal": {
                    "title": "Impostazioni sulla privacy",
                    "acceptAllBtn": "Accetta tutto",
                    "acceptNecessaryBtn": "Rifiuta tutto",
                    "savePreferencesBtn": "Gestisci preferenze",
                    "closeIconLabel": "Chiudi la finestra",
                    "serviceCounterLabel":"Servizi",
                    "sections": [
                        {
                            "title": "Utilizzo dei Cookie",
                            "description": "Utilizziamo cookie, pixel e tecnologie simili per offrire un'esperienza ottimale con le nostre liste dei desideri. Inoltre, analizziamo il comportamento dei nostri utenti per migliorare costantemente Wishbob."
                        },
                        {
                            "title": "Cookie necessari <span class=\"pm__badge\">Sempre Attivati</span>",
                            "description": "I cookie necessari sono richiesti per rendere il sito web utilizzabile. Poiché consentono le funzioni di base del sito, non possono essere disattivati.",
                            "linkedCategory": "necessary"
                        },
                        {
                            "title": "Cookie analitici",
                            "description": "I cookie statistici raccolgono informazioni sull'utilizzo dei siti web. Le informazioni vengono raccolte in forma anonima al fine di migliorare i contenuti e le funzionalità di Wishbob per gli utenti.",
                            "linkedCategory": "analytics",
                        },
                        {
                            "title": "Cookie pubblicitari",
                            "description": "I cookie di marketing sono utilizzati per tracciare i visitatori di siti web.",
                            "linkedCategory": "marketing"
                        },
                        {
                            "title": "Ulteriori informazioni",
                            "description": "Ulteriori informazioni sono disponibili sotto la voce  <a class=\"cc__link\" href=\"/protezione-dati\">protezione dati</a>."
                        },
                        {
                            "title": "L'ID del consenso",
                            "description": "<span id=\"js-cc-cookie-consent-id\"></span>"
                        }
                    ]
                }
            },

            nl: {
                 "consentModal": {
                    "label": "Cookie toestemming",
                    "title": "Deze website gebruikt cookies",
                    "description": "Welkom bij Wishbob! We gebruiken cookies, pixels en vergelijkbare technologieën om een optimale ervaring met onze zoeklijsten aan te bieden. Daarnaast analyseren we het gedrag van onze gebruikers om Wishbob voortdurend te verbeteren. Geef ons daarom je vertrouwen en sta ons toe deze functies te gebruiken. Je kunt de instellingen vrij kiezen en ook achteraf nog aanpassen.",
                    "acceptAllBtn": "Alles accepteren",
                    "acceptNecessaryBtn": "Alles afwijzen",
                    "showPreferencesBtn": "Instellingen beheren",
                    "footer": "<a href=\"/gegevensbescherming\">Gegevensbescherming</a>"
                },
                "preferencesModal": {
                    "title": "Privacy-instellingen",
                    "acceptAllBtn": "Alles accepteren",
                    "acceptNecessaryBtn": "Alles afwijzen",
                    "savePreferencesBtn": "Instellingen opslaan",
                    "closeIconLabel": "Venster sluiten",
                    "serviceCounterLabel": "Diensten",
                    "sections": [
                        {
                            "title": "Gebruik van cookies",
                            "description": "We gebruiken cookies, pixels en vergelijkbare technologieën om een optimale ervaring met onze verlanglijstjes aan te bieden. Daarnaast analyseren we het gedrag van onze gebruikers om Wishbob voortdurend te verbeteren."
                        },
                        {
                            "title": "Noodzakelijke cookies <span class=\"pm__badge\">Altijd geactiveerd</span>",
                            "description": "Noodzakelijke cookies zijn nodig om de website bruikbaar te maken. Omdat ze de basisfuncties van de website mogelijk maken, kunnen ze niet worden gedeactiveerd.",
                            "linkedCategory": "necessary"
                        },
                        {
                            "title": "Statistieken cookies",
                            "description": "Statistische cookies verzamelen informatie over hoe websites worden gebruikt. De informatie wordt anoniem verzameld om de inhoud en functionaliteit van Wishbob voor gebruikers te verbeteren.",
                            "linkedCategory": "analytics",
                        },
                        {
                            "title": "Marketing cookies",
                            "description": "Marketing cookies worden gebruikt om bezoekers van websites te volgen.",
                            "linkedCategory": "marketing"
                        },
                        {
                            "title": "Meer informatie",
                            "description": "Meer informatie vindt u onder <a class=\"cc__link\" href=\"/gegevensbescherming\">gegevensbescherming</a>."
                        },
                        {
                            "title": "Je toestemmings-ID",
                            "description": "<span id=\"js-cc-cookie-consent-id\"></span>"
                        }

                    ]
                }
            }
        }
    }
});

function showConsentID(){
    if(CookieConsent.validConsent()){
        // consent is valid
        const cookie = CookieConsent.getCookie();
        const consent_id = cookie.consentId;
        document.getElementById('js-cc-cookie-consent-id').innerHTML = consent_id;
    }
}

function logConsent(){
    // Retrieve all the fields
    const cookie = CookieConsent.getCookie();
    const preferences = CookieConsent.getUserPreferences();

    // In this example we're saving only 4 fields
    const userConsent = {
        consentId: cookie.consentId,
        acceptType: preferences.acceptType,
        acceptedCategories: preferences.acceptedCategories,
        rejectedCategories: preferences.rejectedCategories,
        acceptedServices: preferences.acceptedServices,
        rejectedServices: preferences.rejectedServices
    };

    // Send the data to your backend
    fetch('/json/logCookieConsent', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userConsent)
    });
}